import { CustomAttributes } from "components/CustomAttributes/CustomAttributes";
import { useMessage } from "hooks/intl";
import { RewardType } from "types/tierSets";
import { OLDate } from "utilities/dateFormat";
import { useStyles } from "./styles";

interface Props {
  rewards: RewardType[];
}
export const Benefits = ({ rewards }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <section className={classes.boxWrapper}>
      <header className={`${classes.header} ${classes.capitalized}`}>
        {message({ id: "tierBenefits" })}
      </header>
      {rewards.map((reward, index) => {
        return (
          <div>
            <header className={classes.subHeader}>
              {message({ id: "benefit" })} {index + 1}
            </header>
            <div className={classes.item}>
              <span className={classes.itemName}>
                {message({ id: "benefitName" })}
              </span>
              <span className={classes.itemValue}>{reward.name}</span>
            </div>
            <div className={classes.item}>
              <span className={classes.itemName}>
                {message({ id: "benefitCode" })}
              </span>
              <span className={classes.itemValue}>{reward.code}</span>
            </div>
            <div className={classes.item}>
              <span className={classes.itemName}>
                {message({ id: "startAt" })}
              </span>
              <span className={classes.itemValue}>
                {OLDate(reward.startAt, {
                  formatString: "dd MMM, yyyy hh:mm aaaaa'm'",
                })}
              </span>
            </div>
            <div className={classes.item}>
              <span className={classes.itemName}>
                {message({ id: "endAt" })}
              </span>
              <span className={classes.itemValue}>
                {OLDate(reward.endAt, {
                  formatString: "dd MMM, yyyy hh:mm aaaaa'm'",
                })}
              </span>
            </div>
            <div className={classes.item}>
              <span className={classes.itemName}>
                {message({ id: "value" })}
              </span>
              <span className={classes.itemValue}>{reward.value}</span>
            </div>
            <div className={classes.item}>
              <span className={classes.itemName}>
                {message({ id: "customAttributes" })}
              </span>
              <span className={classes.itemValue}>
                {reward.labels?.length > 0 ? (
                  <CustomAttributes attributes={reward.labels} />
                ) : (
                  "-"
                )}
              </span>
            </div>
          </div>
        );
      })}
    </section>
  );
};
